var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20H18C17.4477 20 17 20.4477 17 21V37C17 37.5523 17.4477 38 18 38H38C38.5523 38 39 37.5523 39 37V21C39 20.4477 38.5523 20 38 20Z",
    stroke: "#77787B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20C23 18.6739 23.5268 17.4021 24.4645 16.4645C25.4021 15.5268 26.6739 15 28 15C29.3261 15 30.5979 15.5268 31.5355 16.4645C32.4732 17.4021 33 18.6739 33 20",
    stroke: "#77787B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.e0115f72e3ac16d9dde9290d549399f8.svg";
export { ForwardRef as ReactComponent };